import { CommonModule } from '@angular/common';
import { Component, Input, forwardRef } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { formatEducationalItemLabel } from './educational-content-view-model';
import { EducationalFieldLabelPipe } from './educational-field-label.pipe';

@Component({
  selector: 'app-educational-content-value-block',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    EducationalFieldLabelPipe,
    forwardRef(() => EducationalContentValueBlockComponent),
  ],
  templateUrl: './educational-content-value-block.component.html',
  styleUrl: './educational-content-value-block.component.css',
})
export class EducationalContentValueBlockComponent {
  @Input() value: unknown = null;
  @Input() depth = 0;
  @Input() embedMode = false;

  readonly maxDepth = 8;

  itemLabel(v: unknown): string {
    return formatEducationalItemLabel(v);
  }

  isRecord(v: unknown): v is Record<string, unknown> {
    return v !== null && typeof v === 'object' && !Array.isArray(v);
  }

  isArrayValue(v: unknown): v is unknown[] {
    return Array.isArray(v);
  }

  isPrimitive(v: unknown): boolean {
    return (
      v === null ||
      v === undefined ||
      typeof v === 'string' ||
      typeof v === 'number' ||
      typeof v === 'boolean'
    );
  }

  objectKeys(obj: Record<string, unknown>): string[] {
    return Object.keys(obj).sort((a, b) => a.localeCompare(b));
  }

  headingClass(): string {
    return this.embedMode ? 'h6 fw-semibold mb-1' : 'text-sm font-semibold text-slate-700 mb-1';
  }
}
